<template>
  <div class="h-24 bg-white border-t border-grey-light flex flex-col">
    <!-- Barra de estado (status bar) -->
    <div class="h-6 bg-grey-lightest border-b border-grey-light flex items-center justify-between px-4">
      <div class="flex items-center">
        <span class="text-xs text-grey-dark">{{ $t('working_on_the_view') }}:&nbsp;</span>
        <span class="text-gray-700 lowercase font-semibold text-xs">{{ name_vista }}
        </span>
      </div>
      <div class="flex items-center">
        <span class="text-xs text-grey-dark">{{ $t('selected_elements') }}:&nbsp;</span>
        <span class="text-gray-700 font-semibold text-xs">{{ selectedCount || 0 }}</span>
      </div>
    </div>

    <div class="epc-toolbar flex-1 flex items-center justify-center space-x-6 px-4">
      <div class="epc-control-group">
        <div id="toolbar-panTool" class="epc-button inactive"
          :class="{ 'active' : isDraggable }"
          @click="$emit('epc-click-pan')">
          <b-icon pack="fas" icon="hand-paper"></b-icon>
        </div>
        <div id="toolbar-fitTools" class="epc-button inactive"
          @click="$emit('epc-click-fit')">
          <b-icon pack="fas" icon="arrows-to-circle"></b-icon>
        </div>
        <div id="toolbar-zoomInTools" class="epc-button inactive"
          @click="$emit('epc-click-zoom-in', true)">
          <b-icon pack="fas" icon="search-plus"></b-icon>
        </div>
        <div id="toolbar-zoomOutTools" class="epc-button inactive"
          @click="$emit('epc-click-zoom-out', false)">
          <b-icon pack="fas" icon="search-minus"></b-icon>
        </div>

        <div id="toolbar-progressTools" class="epc-button inactive"
          @click="$emit('epc-click-progress')">
          <b-icon pack="fas" icon="bars-progress"></b-icon>
        </div>

        <div id="toolbar-fullscreenTools" class="epc-button inactive"
          @click="$emit('epc-click-fullscreen')">
          <b-icon pack="fas" icon="expand"></b-icon>
        </div>
      </div>

      <div v-if="showSave" class="epc-control-group">
        <div id="toolbar-saveTools" class="epc-button inactive"
          @click="$emit('epc-click-save')">
          <b-icon pack="fas" icon="save"></b-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewerFooterDesign",

  props: {
    name_vista: { type: String, default: null },
    selectedCount: { type: Number, default: 0 },
    isDraggable: { type: Boolean, default: false },
    showSave: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.epc-toolbar {
  pointer-events: none;
  text-align: center;
  z-index: 5;
}

.epc-toolbar .epc-control-group {
  background-color: rgba(34,34,34,.94);
  box-shadow: 1px 3px 10px 0 rgba(0,0,0,.5);
  color: #f4f4f4;
  border-radius: 5px;
  display: inline-block;
  margin: 0 5px;
  pointer-events: all;
}

.epc-button {
  border: 1px solid rgba(34,34,34,0);
  border-radius: 4px;
  cursor: pointer;
  float: left;
  margin: 4px;
  padding: 6px;
  position: relative;
}

.epc-button:hover,
.epc-button.active {
  border: 1px solid #00bfff;
  color: #00bfff;
}

.epc-button.active,
.epc-button:focus {
  border-radius: 3px;
  box-shadow: inset 0 2px 2px 0 #000;
  color: #00bfff;
  outline: none;
}
</style>
